import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';

import { DataGrid, SectionTitle } from 'modules/shared/components';
import { calculateAge, capitalizeString, formatDate } from 'modules/shared/utils';

export default function PersonalDetailsView({ data = {} }: { data?: Record<string, any> }) {
  const columns = [
    {
      rows: [
        {
          type: 'customRow',
          render: () => <PhotoPreview photo={data.photo} />,
        },
        { label: 'Full name', value: data.name },
        { label: 'Date of birth', value: formatDate(data.dateOfBirth) },
        { label: 'Age', value: calculateAge(data.dateOfBirth) },
        { label: 'Gender', value: capitalizeString(data.gender) },
      ],
    },
    {
      rows: [
        { label: 'Contact number', value: data.contact },
        { label: 'Email ID', value: data.email },
        { label: 'Residential address', value: data.residentialAddress },
        { label: 'Permanent address', value: data.permanentAddress },
        { label: 'Nationality', value: data.nationality },
        { label: 'Medical condition', value: data.medicalCondition ?? '-' },
      ],
    },
  ];

  return (
    <div className='column gap-3'>
      <SectionTitle title='Personal details' variant='subtitle' />
      <DataGrid columns={columns} />
    </div>
  );
}

function PhotoPreview({ photo }) {
  return (
    <div className='data-grid-row'>
      <Box
        sx={{
          width: 100,
          height: 100,
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'grey.300',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& img': { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' },
          color: (theme) => alpha(theme.palette.grey[500], 0.5),
        }}
      >
        {photo?.url ? (
          <img src={photo.url} alt='' />
        ) : (
          <Icon icon='fluent:person-16-filled' width={80} />
        )}
      </Box>
    </div>
  );
}
